// src/theme/moonTheme.ts
import { createTheme } from '@mantine/core';

export const moonTheme = createTheme({
  colors: {
    midnight: [
      '#e3f6ff',
      '#c1e9ff',
      '#8fd4ff',
      '#5dc0ff',
      '#2bafff',
      '#009dff',
      '#007bcc',
      '#005999',
      '#003766',
      '#001633',
    ],
  },
  primaryColor: 'midnight',
  primaryShade: { light: 6, dark: 4 },
  fontFamily: 'Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  headings: {
    fontFamily: 'Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    fontWeight: '650',
  },
  black: '#101828',
  white: '#ffffff',
  shadows: {
    xs: '0 1px 2px rgba(16, 24, 40, 0.05)',
    sm: '0 2px 8px rgba(16, 24, 40, 0.06)',
    md: '0 8px 24px rgba(16, 24, 40, 0.08)',
  },
  defaultRadius: 'sm',
  components: {
    Button: { defaultProps: { radius: 'sm' } },
    Card: { defaultProps: { radius: 'md', withBorder: true } },
    Paper: { defaultProps: { radius: 'md' } },
  },
});
